import React from 'react';
import { Image, ImageProps } from '@chakra-ui/react';

interface LogoProps extends Omit<ImageProps, 'src'> {
  variant?: 'blue' | 'white' | 'blue-black' | 'symbol';
}

export const Logo: React.FC<LogoProps> = ({ variant = 'blue', ...props }) => {
  const logoMap = {
    'blue': '/piloto/logo-azul.png',
    'white': '/piloto/logo-branco.png',
    'blue-black': '/piloto/logo-azul-e-preto.png',
    'symbol': '/piloto/logo-simbolo.png'
  };

  return (
    <Image
      src={logoMap[variant]}
      alt="Piloto Logo"
      {...props}
    />
  );
};
